import { eff } from "@/core/utils/effect-ts-abbr";
import { formatCurrency } from "@/core/utils/format-currency";
import { Prop, Vue } from "vue-property-decorator";

export class AppFormatCurrencyComponent extends Vue {
    @Prop({ required: true })
    value!: bigint | number;

    @Prop({ default: "EUR", type: String })
    currency!: string;

    @Prop()
    options?: Omit<Intl.NumberFormatOptions, "style">;

    get formattedValue() {
        return eff.fn.pipe(
            this.value,
            formatCurrency({ ...(this.options || {}), currency: this.currency }),
        );
    }
}
